import * as React from "react";

export function useIsMobileOrTab(breakpoint = 1024) {
  const [isMobileOrTab, setIsMobileOrTab] = React.useState(false);
  React.useEffect(() => {
    function handleResize() {
      setIsMobileOrTab(window.innerWidth < breakpoint);
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);
  return isMobileOrTab;
}
